/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsRotateH: {
  name: 'arrows-rotate-h';
  data: string;
} = {
  name: 'arrows-rotate-h',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 5A7.003 7.003 0 0 0 5.51 9.375a1 1 0 1 1-1.854-.75A9.003 9.003 0 0 1 19.589 7.16l.457-1.459a1 1 0 0 1 1.909.598l-1.252 4a1 1 0 0 1-1.213.667l-3.747-1a1 1 0 1 1 .515-1.932l1.817.485A6.999 6.999 0 0 0 12 5Zm-8.702 8.701a1 1 0 0 1 1.212-.667l3.748 1a1 1 0 0 1-.516 1.932l-1.816-.484a7.003 7.003 0 0 0 12.566-.857 1 1 0 1 1 1.854.75A9.003 9.003 0 0 1 4.41 16.84l-.456 1.459a1 1 0 1 1-1.91-.598l1.253-4Z" fill="currentColor"/></svg>`,
};
